import { acceptStringValue } from '../../field-viewer/shared-normalizers';
export const dextDatePickerViewer = {
    normalizeLoadedValue: acceptStringValue
};

//# sourceMappingURL=definition-viewer.js.map